import { range } from "@formant/core/common/range";

import { ComplexRoutePattern, RouteParam } from "./IRoute";

function warnMalformed(
    str: string,
    side: "leading" | "trailing",
    debugName: string,
) {
    console.warn(`malformed path part: missing ${side} "/" for "${debugName}"`);
    return str;
}

function trim(source: string, optionalTrailing: boolean, debugName: string) {
    if (source === "") {
        return "";
    }

    let trimmed = source;
    trimmed = trimmed.startsWith("/")
        ? trimmed.substring(1)
        : warnMalformed(trimmed, "leading", debugName);

    if (!optionalTrailing && trimmed.length > 0) {
        trimmed = trimmed.endsWith("/")
            ? trimmed.substring(0, trimmed.length - 1)
            : warnMalformed(trimmed, "trailing", debugName);
    }

    return trimmed;
}

const processPathLiteral = (part: string): RouteParam | string =>
    part.startsWith(":") ? { param: part as `:${string}` } : part;

export function path(
    pathParts: TemplateStringsArray,
    ...params: RouteParam[]
): ComplexRoutePattern {
    const debugName = pathParts.reduce((str, part, idx) => {
        return `${str}${part}${params[idx] ? params[idx].param : ""}`;
    }, "");

    const max = pathParts.length;
    return range(0, max).reduce<ComplexRoutePattern>((route, idx) => {
        const isLast = idx === max - 1;
        const trimmedPart = trim(pathParts[idx], isLast, debugName);

        if (trimmedPart.length) {
            const parts = trimmedPart.split("/").map(processPathLiteral);
            route.push(...parts);
        }

        const nextParam = params[idx];
        if (nextParam) {
            route.push(nextParam);
        }

        return route;
    }, []);
}
